(function () {
  'use strict';
  var slot = document.querySelector('[data-pf-order-strings]'); if (!slot || window.PFOrderTools) return;
  var t = JSON.parse(slot.textContent), api = window.PFApi;
  var productsSlot = document.querySelector('[data-pf-order-products]');
  var products = productsSlot ? JSON.parse(productsSlot.textContent) : {};
  function element(tag, value, className) { var node = document.createElement(tag); if (value) node.textContent = value; if (className) node.className = className; return node; }
  function button(label, action) { var node = element('button', label); node.type = 'button'; node.addEventListener('click', action); return node; }
  function money(value) { if (!value) return ''; try { return new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: value.currencyCode }).format(Number(value.amount)); } catch (_) { return value.amount + ' ' + value.currencyCode; } }
  function safeLink(url) { try { var parsed = new URL(url); return parsed.protocol === 'https:' ? parsed.toString() : null; } catch (_) { return null; } }
  function variantId(value) { return String(value == null ? '' : value).split('/').pop(); }
  function orderLine(item, order) {
    var lines = order && Array.isArray(order.lineItems) ? order.lineItems : [];
    return lines.find(function (line) { return variantId(line.variantId) === variantId(item.id); }) ||
      lines.find(function (line) { return line.title === item.title; }) || {};
  }
  function productLink(item) {
    var direct = safeLink(item.productUrl);
    if (direct) return direct;
    var base = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
    if (item.productHandle) return base + 'products/' + encodeURIComponent(item.productHandle) + '?variant=' + encodeURIComponent(item.id || '');
    return products[item.title] ? products[item.title].url : null;
  }
  function itemPrice(line) { return line.price || line.unitPrice || line.originalUnitPrice || null; }
  function showReorder(plan, order, source, status) {
    var modal = element('dialog', '', 'pf-account-dialog pf-reorder-dialog');
    modal.setAttribute('aria-labelledby', 'pf-reorder-title');
    var shell = element('div', '', 'pf-reorder-dialog__shell');
    var head = element('header', '', 'pf-reorder-dialog__head');
    var heading = element('div');
    var eyebrow = element('span', t.reorder, 'pf-reorder-dialog__eyebrow');
    var title = element('h2', t.reorder_title); title.id = 'pf-reorder-title';
    heading.append(eyebrow, title, element('p', t.reorder_hint));
    var closeIcon = button('\u00d7', function () { modal.close(); });
    closeIcon.className = 'pf-reorder-dialog__close';
    closeIcon.setAttribute('aria-label', t.close);
    head.append(heading, closeIcon);
    shell.append(head);

    var list = element('div', '', 'pf-reorder-dialog__items');
    var rows = [];
    (plan.items || []).forEach(function (item) {
      var line = orderLine(item, order);
      var row = element('article', '', 'pf-reorder-item');
      var href = productLink(item);
      var media = element(href ? 'a' : 'span', '', 'pf-reorder-item__media');
      if (href) { media.href = href; media.setAttribute('aria-label', item.title); }
      var image = item.image || line.image || line.imageUrl || (products[item.title] && products[item.title].image);
      if (image) { var img = document.createElement('img'); img.src = image; img.alt = ''; img.loading = 'lazy'; media.append(img); }
      else media.append(element('span', '', 'pf-reorder-item__placeholder'));

      var copy = element('div', '', 'pf-reorder-item__copy');
      var itemTitle = element(href ? 'a' : 'strong', item.title, 'pf-reorder-item__title');
      if (href) itemTitle.href = href;
      copy.append(itemTitle);
      var currentVariantTitle = item.variantTitle || line.variantTitle;
      if (currentVariantTitle && currentVariantTitle !== 'Default Title') copy.append(element('span', currentVariantTitle, 'pf-reorder-item__variant'));
      var unit = itemPrice(item) || itemPrice(line);
      if (unit) copy.append(element('span', money(unit), 'pf-reorder-item__price'));

      var quantity = element('div', '', 'pf-reorder-item__quantity');
      quantity.setAttribute('role', 'group');
      quantity.setAttribute('aria-label', t.quantity + ': ' + item.title);
      var decrease = button('\u2212', function () { input.value = String(Math.max(1, Number(input.value) - 1)); updateSummary(); });
      decrease.setAttribute('aria-label', t.decrease_quantity);
      var input = document.createElement('input');
      var maximum = Math.max(1, Math.min(99, Number(item.maximumQuantity) || Number(item.quantity) || 1));
      input.type = 'number'; input.min = '1'; input.max = String(maximum); input.step = '1'; input.value = String(Math.min(maximum, Number(item.quantity) || 1)); input.inputMode = 'numeric';
      input.setAttribute('aria-label', t.quantity + ': ' + item.title);
      var increase = button('+', function () { input.value = String(Math.min(maximum, Number(input.value) + 1)); updateSummary(); });
      increase.setAttribute('aria-label', t.increase_quantity);
      input.addEventListener('change', function () { input.value = String(Math.min(maximum, Math.max(1, parseInt(input.value, 10) || 1))); updateSummary(); });
      quantity.append(decrease, input, increase);
      row.append(media, copy, quantity);
      list.append(row);
      rows.push({ item: item, line: line, unit: unit, input: input });
    });

    (plan.unavailable || []).forEach(function (item) {
      var href = productLink(item);
      var row = element('article', '', 'pf-reorder-item pf-reorder-item--unavailable');
      var copy = element('div', '', 'pf-reorder-item__copy');
      copy.append(element('strong', item.title, 'pf-reorder-item__title'));
      copy.append(element('span', t.unavailable + ': ' + item.reason, 'pf-reorder-item__reason'));
      if (href) { var product = element('a', t.view_product, 'pf-reorder-item__alternative'); product.href = href; copy.append(product); }
      row.append(copy);
      list.append(row);
    });
    shell.append(list);
    if (!rows.length) shell.append(element('p', t.no_items, 'pf-reorder-dialog__empty'));

    var footer = element('footer', '', 'pf-reorder-dialog__footer');
    var summaryNode = element('p', '', 'pf-reorder-dialog__summary');
    var message = element('p', '', 'pf-reorder-dialog__message'); message.setAttribute('role', 'status');
    var actions = element('div', '', 'pf-reorder-dialog__actions');
    var adding = false;
    var cancel = button(t.cancel, function () { modal.close(); }); cancel.className = 'pf-reorder-dialog__cancel';
    actions.append(cancel);
    var add;
    function updateSummary() {
      var count = rows.reduce(function (sum, row) { return sum + Number(row.input.value); }, 0);
      var priced = rows.filter(function (row) { return row.unit; });
      var amount = priced.reduce(function (sum, row) { return sum + Number(row.unit.amount) * Number(row.input.value); }, 0);
      var currency = priced[0] && priced[0].unit.currencyCode;
      summaryNode.textContent = t.selected_items.replace('{count}', String(count));
      if (priced.length === rows.length && currency) summaryNode.textContent += ' \u00b7 ' + t.estimated_subtotal.replace('{amount}', money({ amount: amount, currencyCode: currency }));
    }
    if (rows.length) {
      add = button(t.add_cart, async function () {
        if (adding) return;
        adding = true; add.disabled = true; cancel.disabled = true; closeIcon.disabled = true; message.textContent = t.adding;
        var selected = rows.map(function (row) { return { id: row.item.id, quantity: Number(row.input.value) }; });
        var completed = 0;
        try {
          var base = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
          for (var offset = 0; offset < selected.length; offset += 50) {
            var batch = selected.slice(offset, offset + 50);
            var response = await fetch(base + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: batch }) });
            var result = await response.json(); if (!response.ok) throw new Error(result.description || t.error); completed += batch.length;
          }
          location.assign(base + 'cart');
        } catch (error) {
          message.textContent = (completed ? t.partial_added : t.check_cart) + ' ' + error.message;
          var cart = element('a', t.review_cart, 'pf-reorder-dialog__cart-link');
          var cartBase = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
          cart.href = cartBase + 'cart';
          message.after(cart); cancel.disabled = false; closeIcon.disabled = false;
        }
      });
      add.className = 'pf-reorder-dialog__add'; add.setAttribute('data-pf-reorder-confirm', ''); actions.append(add);
    }
    footer.append(summaryNode, message, actions); shell.append(footer); modal.append(shell);
    updateSummary();
    modal.addEventListener('click', function (event) { if (event.target === modal && !adding) modal.close(); });
    modal.addEventListener('cancel', function (event) { if (adding) event.preventDefault(); });
    modal.addEventListener('close', function () { modal.remove(); if (source) source.focus(); });
    document.body.append(modal); modal.showModal();
  }
  async function reorder(order, source, status) {
    source.disabled = true;
    try {
      var plan = await api.post('/v1/me/orders/' + order.id + '/reorder', {});
      showReorder(plan, order, source, status);
    } catch (error) { status.textContent = error.message || t.error; }
    finally { source.disabled = false; }
  }
  function render(panel, order) {
    if (panel.__pfOrderTools) return; panel.__pfOrderTools = true;
    ['.pf-summary__mobile', '.pf-summary__desktop'].forEach(function (selector) {
      var view = panel.querySelector(selector); if (!view) return;
      var actions = view.querySelector('[data-pf-order-actions]'); if (!actions) return;
      var payment = view.querySelector('[data-pf-payment-card]');
      if (payment) {
        payment.querySelector('[data-pf-payment-method]').textContent = order.paymentMethod || '';
        payment.hidden = !order.paymentMethod;
      }
      var totals = view.querySelector('[data-pf-payment-totals]');
      if (totals) {
        totals.replaceChildren();
        [['totalReceived', 'received'], ['totalRefunded', 'refunded'], ['totalOutstanding', 'outstanding']].forEach(function (pair) {
          if (!order[pair[0]] || !Number(order[pair[0]].amount)) return;
          var row = element('div'); row.append(element('dt', t[pair[1]]), element('dd', money(order[pair[0]]))); totals.append(row);
        });
        totals.hidden = !totals.childElementCount;
      }
      var note = view.querySelector('[data-pf-order-note]'); if (note) note.hidden = false;
      var shipmentsCard = view.querySelector('[data-pf-shipments-card]');
      var shipments = view.querySelector('[data-pf-shipments]');
      if (shipments) shipments.replaceChildren();
      (order.fulfillments || []).forEach(function (shipment, index) {
        if (!shipments) return;
        var article = element('article', '', 'pf-summary__shipment'); article.dataset.pfShipment = shipment.id;
        var head = element('header', '', 'pf-summary__shipment-head');
        head.append(element('h3', t.shipment.replace('{number}', String(index + 1))));
        var state = String(shipment.status || shipment.fulfillmentStatus || '').toLowerCase().replace(/_/g, ' ');
        if (state) head.append(element('span', state.charAt(0).toUpperCase() + state.slice(1), 'pf-summary__shipment-status'));
        article.append(head);
        var items = element('ul', '', 'pf-summary__shipment-items'); items.setAttribute('role', 'list');
        (shipment.lineItems || []).forEach(function (item) { items.append(element('li', (item.lineItem && item.lineItem.title || item.title || '') + ' × ' + item.quantity)); });
        if (items.childElementCount) article.append(items);
        (shipment.tracking || []).forEach(function (track) {
          var tracking = element('div', '', 'pf-summary__shipment-tracking');
          if (track.company) tracking.append(element('strong', track.company));
          var href = safeLink(track.url), link = element(href ? 'a' : 'span', track.number || (href ? t.track : ''));
          if (href) { link.href = href; link.target = '_blank'; link.rel = 'noopener'; }
          if (link.textContent) tracking.append(link);
          if (tracking.childElementCount) article.append(tracking);
        });
        shipments.append(article);
      });
      if (shipmentsCard) shipmentsCard.hidden = !shipments || !shipments.childElementCount;
      var status = element('p', '', 'pf-summary__action-status'); status.setAttribute('role', 'status');
      var secondary = element('div', '', 'pf-summary__secondary-actions');
      Array.prototype.forEach.call(actions.querySelectorAll('a'), function (link) {
        link.classList.remove('pf-summary__buy', 'pf-summary__invoice'); link.classList.add('pf-summary__secondary-link'); secondary.append(link);
      });
      var invoice = button(t.invoice, async function () {
        invoice.disabled = true; status.textContent = '';
        try { var blob = await api.get('/v1/me/orders/' + order.id + '/invoice', { responseType: 'blob' }); var url = URL.createObjectURL(blob); var link = element('a'); link.href = url; link.download = 'invoice-' + order.id + '.pdf'; document.body.append(link); link.click(); link.remove(); setTimeout(function () { URL.revokeObjectURL(url); }, 30000); }
        catch (error) { status.textContent = error.message || t.error; } finally { invoice.disabled = false; }
      }); invoice.setAttribute('data-pf-invoice', ''); invoice.classList.add('pf-summary__invoice');
      var buy = button(t.reorder, function () { reorder(order, buy, status); }); buy.setAttribute('data-pf-reorder', '');
      buy.classList.add('pf-summary__buy');
      actions.replaceChildren(buy, invoice); actions.after(secondary, status);
    });
  }
  document.addEventListener('pf:order:detail', function (event) { render(event.detail.panel, event.detail.order); });
  function scan() { document.querySelectorAll('[data-order-id]').forEach(function (panel) { if (panel.__pfOrder) render(panel, panel.__pfOrder); }); }
  document.addEventListener('pf:profile:hydrated', scan); scan();
  window.PFOrderTools = { render: render, openReorder: showReorder };
})();
